



















import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import AppForm from '@core/components/AppForm.vue'
import { FormStructure } from '@master/model/structure/FormStructure'
import PersonalDetailsMeta from './model/PersonalDetailsMeta'
import { UserAdviserDetailsMeta } from './model/UserAdviserDetailsMeta'
import { FinancingPaymentStructure } from '@master/enum/AdviserFinancingEnum'
import { BankBicOptions } from '@master/model/options/BankBicOptions'

const userStore = namespace('UserStore')
@Component({
  components: {
    AppForm
  }
})
export default class TheFinancingDetails extends Vue {
  @userStore.State
  private userAdviserDetails!: UserAdviserDetailsMeta;

  get personalDetails () {
    return this.userAdviserDetails.personalDetails
  }

  get bankOption () {
    return BankBicOptions.map(bank => {
      return {
        label: bank.NAME,
        value: bank.CODE
      }
    })
  }

  get financialStructure (): FormStructure<PersonalDetailsMeta> {
    return [
      {
        label: 'Type of Financing',
        key: 'financingType'
      },
      {
        label: 'Reason for Financing',
        key: 'reasons'
      },
      {
        label: 'Payment Structure',
        key: 'paymentStructure',
        options: this.paymentStructureOption
      }
    ]
  }

  get personalBankStructure (): FormStructure<PersonalDetailsMeta> {
    return [
      {
        label: 'Bank Name',
        key: 'bankName', // remain as bankName as existing db stored as bank name
        options: this.bankOption
      },
      {
        label: 'Branch Name/ Code',
        key: 'branchName'
      },
      {
        label: 'Bank Account No',
        key: 'bankAccountNo'
      }
    ]
  }

  get overridingBankStructure (): FormStructure<PersonalDetailsMeta> {
    return [
      {
        label: 'Bank Name',
        key: 'overridingBankCode',
        options: this.bankOption
      },
      {
        label: 'Branch Name/ Code',
        key: 'overridingBankBranchCode'
      },
      {
        label: 'Bank Account No',
        key: 'overridingBankAccountNo'
      }
    ]
  }

  get paymentStructureOption () {
    return Object.values(FinancingPaymentStructure)
      .filter((v) => isNaN(Number(v)))
      .map((paymentStructure) => {
        return {
          label: paymentStructure as string,
          value: FinancingPaymentStructure[paymentStructure].toString()
        }
      })
  }
}
